import "regenerator-runtime/runtime";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./global-components";
import "./utils";
import "./libs";
import VueHtml2Canvas from "vue-html2canvas";

// Midone Theme
import "./assets/sass/app.scss";

window.host = `${process.env.VUE_APP_CCD_HOST}`;
window.homepage = `${process.env.VUE_APP_CCD_CLIENT_URL}`;
window.api = `${process.env.VUE_APP_CCD_API}`;
window.mapKey = `${process.env.VUE_APP_GOOGLE_MAP_KEY}`;

Vue.config.productionTip = false;

Vue.filter("percentage", function(value) {
  if (!value) return "0.0%";
  return value.toFixed(1) + "%";
});

Vue.use(VueHtml2Canvas);

Vue.mixin({
  methods: {
    downloadCanvas(ref, titleRef = "title") {
      const component = this.$refs[ref];
      const title = this.$refs[titleRef] ?? false;
      if (title) title.classList.remove("hidden");

      component.classList.add("px-4");
      component.classList.add("py-2");
      // const canvas = component.$refs.canvas;
      const link = document.createElement("a");
      link.download = `${ref}.png`;
      let canvas = this.$html2canvas(component, { type: "dataURL" });
      canvas.then(function(blob) {
        link.href = blob;
        link.click();

        if (title) title.classList.add("hidden");
        component.classList.remove("px-4");
        component.classList.remove("py-2");
      }, "image/png");
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
